import React from 'react';
import { translate } from 'react-i18next';
import AdminStepCard from '../../../components/AdminStepCard/AdminStepCard';
import ToggleWithInfo from '../../../components/ToggleWithInfo/ToggleWithInfo';
import CheckboxWithInfo from '../../../components/CheckboxWithInfo/CheckboxWithInfo';
import BreakCalculation from './BreakCalculation/breakCalculation';
import './DataVisibility.scss'

const DataVisibility = ({ dataVisibility, breakRules, handleSettingPropChange, ...props }) => {
    const { t: translate } = props;
    const t = (prop) => translate(`workplanManager:settings.dataVisibility.${prop}`);
    dataVisibility = dataVisibility || {};

    const handleRadioChange = (value) => handleSettingPropChange('dataVisibility', { ...dataVisibility, weeklyHours: value });
    const handleVisibilityChange = (event) => handleSettingPropChange('dataVisibility', { ...dataVisibility, weeklyHoursByDefault: event.target.checked });

    return (
        <AdminStepCard avatar={8} title={t('title')}>
            <ToggleWithInfo
                className='data-toggle'
                checked={dataVisibility.weeklyHours}
                label={t('weeklyHours')}
                onChange={handleRadioChange}
            />
            {
                dataVisibility.weeklyHours && (
                    <div className='data-breakrule-container'>
                        <CheckboxWithInfo
                            className='by-default-checkbox'
                            checked={dataVisibility.weeklyHoursByDefault}
                            label={t('visibleByDefault')}
                            onChange={handleVisibilityChange}
                        />
                        <BreakCalculation
                            breakRules={breakRules}
                            handleChangeSetting={handleSettingPropChange}
                        >
                        </BreakCalculation>
                    </div>
                )
            }
        </AdminStepCard>
    );
}

export default translate('workplanManager')(DataVisibility);